import React from 'react';
import { CarouselTrack } from '../../../ui/Carousel/CarouselTrack';
import { CarouselItem } from '../../../ui/Carousel/CarouselItem';
import { CarouselIndicators } from '../../../ui/Carousel/CarouselIndicators';
import { useCarouselNavigation } from '../../../ui/Carousel/hooks/useCarouselNavigation';
import { FloorPlanCard } from './FloorPlanCard';
import type { Floorplan, Unit } from './UnitTable';
import * as styles from './unitsModule.styles';

type MobileFloorPlanCarouselProps = {
  floorplans: Array<Floorplan>;
  onUnitSelect: (unit: Unit, floorplan: Floorplan) => void;
};

export const MobileFloorPlanCarousel = ({ floorplans, onUnitSelect }: MobileFloorPlanCarouselProps) => {
  const { trackRef, currentPage, totalPages, scrollToPage, handleScroll } = useCarouselNavigation({
    gap: 'md',
    step: 'page',
  });

  return (
    <>
      <CarouselTrack ref={trackRef} gap="md" snapAlign="start" onScroll={handleScroll} aria-label="Floor plans">
        {floorplans.map((fp) => (
          <CarouselItem key={fp.modelId} width="100%">
            <FloorPlanCard floorplan={fp} onUnitSelect={onUnitSelect} />
          </CarouselItem>
        ))}
      </CarouselTrack>

      {floorplans.length > 1 && (
        <div className={styles.dotContainer}>
          <CarouselIndicators currentPage={currentPage} totalPages={totalPages} onPageSelect={scrollToPage} />
        </div>
      )}
    </>
  );
};
